<template>
  <el-dialog
    :visible.sync="visible"
    :title="titleIndex ? '新增细目' : '新增细目1'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form :inline="true" :model="dataForm" label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="选择分类：">
            <el-select
              v-model="dataForm.subContractTypeEnum"
              placeholder="请选择分类"
              @change="subContractTypeChange"
            >
              <el-option label="劳务" value="LABOR"></el-option>
              <el-option label="机械" value="MACHINE"></el-option>
              <el-option label="材料" value="MATERIAL"></el-option>
              <el-option
                v-if="titleIndex == 2"
                label="其他"
                value="OTHERS"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="!(titleIndex == 2 && id)">
          <el-form-item label="合作单位：">
            <el-select
              v-model="dataForm.companyName"
              filterable
              remote
              :remote-method="remoteMethod"
              placeholder="请选择合作单位"
              @change="setValidItem"
            >
              <el-option
                :label="validItem.companyName"
                :value="validItem.companyName"
                v-for="(validItem, validIndex) in validList"
                :key="'validItem' + validIndex"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-else>
          <el-form-item label="合作单位：">
            <el-input
              v-model="partyBName"
              placeholder="合作单位"
              :readonly="true"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div class="titleBox">
          <div>选择细目</div>
        </div>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="细目名称：">
            <el-input
              v-model="dataForm.subCategoryName"
              placeholder="请输入细目名称"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="细目号：">
            <el-input
              v-model="dataForm.subCategoryNo"
              placeholder="请输入细目号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="btnRight">
          <el-form-item class="btnList">
            <el-button type="primary" @click="query()">查 询</el-button>
            <el-button type="info" @click="reset()">重 置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="selectTitleTxt">已选择</div>
    <div class="listBox">
      <div class="noSelectList">
        <el-table
          ref="dataTable"
          :data="noSelectList"
          @row-click="rowNoClicked"
          highlight-current-row
          size="mini"
          height="100%"
          border
        >
          <!--                    <el-table-column type="index" width="50"></el-table-column>-->
          <el-table-column
            :prop="
              dataForm.subContractTypeEnum === 'MATERIAL'
                ? 'productName'
                : 'subCategoryName'
            "
            label="细目名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            :prop="
              dataForm.subContractTypeEnum === 'MATERIAL'
                ? 'productNumber'
                : 'subCategoryNo'
            "
            label="细目号"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="unit"
            label="单位"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="unitPrice"
            label="单价"
            :show-overflow-tooltip="true"
          ></el-table-column>
        </el-table>
      </div>
      <div class="btnList">
        <i class="el-icon-arrow-left" @click="deleteBtn"></i>
        <i class="el-icon-arrow-right" @click="addBtn"></i>
      </div>
      <div class="selectList">
        <el-table
          ref="dataTable1"
          :data="selectList"
          highlight-current-row
          @row-click="rowClicked"
          size="mini"
          height="100%"
          border
        >
          <el-table-column
            :prop="
              dataForm.subContractTypeEnum === 'MATERIAL'
                ? 'productName'
                : 'subCategoryName'
            "
            label="细目名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            :prop="
              dataForm.subContractTypeEnum === 'MATERIAL'
                ? 'productNumber'
                : 'subCategoryNo'
            "
            label="细目号"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="unit"
            label="单位"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="unitPrice"
            label="单价"
            :show-overflow-tooltip="true"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <el-footer class="container">
      <div class="btnMid">
        <el-button type="info" @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="submitBtn()">保 存</el-button>
      </div>
    </el-footer>
  </el-dialog>
</template>

<script>
import {
  queryDetailDataService,
  getSupplierValidListService,
} from "../../../services/engineering";
import {
  saveBatchService, //其他直接费、措施费通过列表行新增细目
  addDetailsService, //措施费顶部按钮新增细目，需要projectId参数
} from "../../../services/feeServices";
export default {
  name: "add-detail",
  data() {
    return {
      visible: false,
      dataForm: {
        subContractTypeEnum: "", //细目类型
        subCategoryName: "", //细目名称
        subCategoryNo: "", //细目号
        validId: "",
        companyName: "",
      },
      validList: [],
      noSelectList: [],
      selectList: [],
      titleIndex: 1, // 其它直接费 1 措施费 2
      rowNoClickedList: null,
      rowClickedList: null,
      subContractTypeEnum: "",
      id: "",
      partyBId: "",
      partyBName: "",
      projectId: "",
      queryTxt: "",
    };
  },
  methods: {
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.noSelectList = [];
        this.selectList = [];
        this.subContractTypeEnum = "";
        this.dataForm = {
          subContractTypeEnum: "", //细目类型
          subCategoryName: "", //细目名称
          subCategoryNo: "", //细目号
        };

        this.getSupplierValidList();
      });
    },
    remoteMethod(query) {
      this.queryTxt = query;
      this.getSupplierValidList();
    },
    getSupplierValidList() {
      let paramsData = {
        isTop: "0",
        topType: "bType",
        pageIndex: 1,
        pageSize: -1, //获取全部数据
        companyName: this.queryTxt,
      };
      getSupplierValidListService(paramsData)
        .then((res) => {
          if (res.code == 10000000) {
            this.validList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    /**
     * 查询列表
     */
    query() {
      if (!this.dataForm.subContractTypeEnum) {
        this.$message.error("请选择分类");
        return;
      }
      let paramsData = {
        ...this.dataForm,
      };
      queryDetailDataService(paramsData)
        .then((res) => {
          if (res.code == 10000000) {
            this.noSelectList = res.data;
            this.selectList = [];
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    //重置
    reset() {
      this.dataForm.subCategoryName = "";
      this.dataForm.subCategoryNo = "";
      if (this.dataForm.subContractTypeEnum) {
        this.query();
      }
    },
    //删除数据
    deleteBtn() {
      if (this.rowClickedList) {
        this.noSelectList.push(this.rowClickedList);
        this.selectList.splice(this.selectList.indexOf(this.rowClickedList), 1);
        this.rowClickedList = null;
      }
    },
    //添加数据
    addBtn() {
      if (this.rowNoClickedList) {
        this.selectList.push(this.rowNoClickedList);
        this.noSelectList.splice(
          this.noSelectList.indexOf(this.rowNoClickedList),
          1
        );
        this.rowNoClickedList = null;
      }
    },
    // 点击选中行
    rowNoClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
      this.rowNoClickedList = row;
    },
    rowClicked(row, event, column) {
      this.$refs.dataTable1.toggleRowSelection(row);
      this.rowClickedList = row;
    },
    subContractTypeChange() {
      if (this.subContractTypeEnum != this.dataForm.subContractTypeEnum) {
        this.query();
        this.subContractTypeEnum = this.dataForm.subContractTypeEnum;
      }
    },
    submitBtn() {
      if (this.selectList.length <= 0) {
        this.$message.warning("请选择细目");
        return;
      }
      let paramsData = {
        // 'id': this.id,
        commonDictIdList: [], //普通
        materialDictIdList: [], //材料
        partyBId: this.dataForm.validId,
        partyBName: this.dataForm.companyName,
      };
      let apiName = saveBatchService;
      if (this.id) {
        paramsData.id = this.id;
        if (this.titleIndex == 2) {
          paramsData.partyBId = this.partyBId;
          paramsData.partyBName = this.partyBName;
        }
      } else if (this.projectId) {
        paramsData.projectId = this.projectId;
        apiName = addDetailsService;
      }
      // 其它直接费
      if (!(this.titleIndex == 2 && this.id) && !this.dataForm.companyName) {
        this.$message.error("请选择合作单位");
        return;
      }
      if (this.subContractTypeEnum == "MATERIAL") {
        paramsData.materialDictIdList = this.selectList.map((item) => {
          return {
            dictId: item.id,            
          };
        });
      } else {
        paramsData.commonDictIdList = this.selectList.map((item) => {
          return {
            dictId: item.id,
            // partyBId: this.dataForm.validId,
            // partyBName: this.dataForm.companyName,
          };
        });
      }
      apiName(paramsData)
        .then((res) => {
          if (res.code == 10000000) {
            this.partyBId = "";
            this.visible = false;
            this.$emit("refreshDataList");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    setValidItem(value) {
      let index = this.validList.findIndex(
        (item) => item.companyName == this.dataForm.companyName
      );
      this.dataForm.validId = this.validList[index].id;
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-dialog {
  width: 70%;
}
.titleBox {
  display: flex;
  color: #101010;
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  font-weight: 600;
  border-bottom: 1px solid #bbbbbb;
  margin: 20px;
  padding-bottom: 10px;
}
.btnRight {
  display: flex;
  justify-content: flex-end;
}
.selectTitleTxt {
  margin-left: 55%;
  color: rgba(61, 61, 62, 100);
  font-size: 14px;
  margin-bottom: 12px;
}
.listBox {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .noSelectList {
    width: 45%;
    height: 200px;
    border: 1px solid rgba(187, 187, 187, 100);
  }
  .btnList {
    width: 5%;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    i {
      font-size: 24px;
      font-weight: 600;
    }
  }
  .selectList {
    width: 45%;
    height: 200px;
    border: 1px solid rgba(187, 187, 187, 100);
  }
}
.container {
  width: 100%;
  margin-top: 60px;
  display: flex;
  justify-content: center;
}
</style>
